/**
 * Checks if the provided value is not `null`, not `undefined`, of type `string` and not an empty string `''` (including checking white spaces)
 * @param value The value to check
 * @returns Type predicate value as non nullable `string` type
 */
export const isDefinedString = (value: unknown): value is NonNullable<string> => {
  if (value == null) return false;
  if (typeof value !== 'string') return false;
  if (value.trim() === '') return false;
  return true;
};
